import {
  Box,
  Card,
  CardContent,
  CardMedia,
  CssBaseline,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useNavigate } from "react-router";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useEffect, useState } from "react";
import axios from "axios";
import axiosInstance, {
  getLocalAccessToken,
} from "../common/services/axiosInstance";
import { useCharactersContext } from "../hooks/Context";
import BasicImage from "../assets/Modules-Basic.svg";
import IntermediateImage from "../assets/Modules-Intermediate.svg";
import AdvancedImage from "../assets/Modules-Advanced.svg";
import testBackground from "../assets/stacked-waves-haikei.svg";

interface Module {
  examinationId: number;
  name: string;
}

const Modules = () => {
  const isMobile = useMediaQuery("(max-width: 600px)");
  const isTablet = useMediaQuery("(max-width: 820px)");
  const isLarge = useMediaQuery("(min-width: 1400px");
  const navigate = useNavigate();
  const BASE_URL = `${process.env.REACT_APP_API_URL}`;
  const [modules, setModules] = useState<Module[]>([]);

  useEffect(() => {
    axiosInstance
      .get("/api/examinationParticipation/examination/get")
      .then((response: any) => {
        console.log(
          "Request sent with headers:",
          axiosInstance.defaults.headers
        );
        console.log("responseData", response.data);
        setModules(response.data);
      })
      .catch((error: any) => {
        console.log(error);
      });
  }, []);

  const { questionScores } = useCharactersContext();

  console.log("questionScores", questionScores);

  console.log("modules", modules);

  return (
    <div
      style={{
        // background: "linear-gradient(to top, #D9F6FF, #FFFFFF)",
        minHeight: "100vh",
        marginTop: "0",
        padding: "0",
        backgroundImage: `url(${testBackground})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginTop: isMobile ? "15.5%" : isTablet ? "8%" : "10vh",
          marginBottom: isMobile ? "2vh" : "5vh",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: isMobile || isTablet ? "5vh" : "7vh",
            flexBasis: "100%",
            flexShrink: 2,
            textAlign: "left",
            fontWeight: "bold",
          }}
        >
          Modules
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          marginLeft: isMobile ? "5%" : "2.5%",
          marginTop: isMobile ? "0.5vh" : "1.5vh",
        }}
      >
        <IconButton
          sx={{
            borderRadius: "50%",
            // height: "3vh",
            "&.MuiIconButton-root": {
              backgroundColor: "primary.main",
              color: "white !important",
            },
            boxShadow: "10",
          }}
          onClick={() => {
            navigate(-1);
          }}
          size="small"
        >
          <ArrowBackIcon />
        </IconButton>
      </Box>
      <Grid
        container
        justifyContent="center"
        // spacing={2}
        // xs={12}
        sx={{
          height: "auto",
          marginTop: isMobile ? "0.5vh" : "1.5vh",
          paddingLeft: isMobile ? "7.5vh" : "6.5vw",
        }}
      >
        {modules
          .slice()
          .sort((a, b) => a.examinationId - b.examinationId)
          .map((module) => (
            <Grid item key={module.examinationId} lg={4} xs={12} sm={6}>
              <Card
                variant="outlined"
                sx={{
                  // borderRadius: "12px",
                  marginLeft: "0",
                  // width: "auto",
                  // height: "auto",
                  cursor: "pointer",
                  // width: isMobile ? "250px" : "250px",
                  // height: isMobile ? "200px" : "200px",
                  marginBottom: isMobile ? "2vh" : "0",
                  backgroundColor: "transparent",
                  boxShadow: "none",
                  border: "none",
                }}
                onClick={() =>
                  navigate(`/modules/${module.examinationId}/levels`)
                }
              >
                <div style={{ position: "relative" }}>
                  <CardMedia
                    component="img"
                    title={module.name}
                    src={
                      module.name === "Basic"
                        ? BasicImage
                        : module.name === "Intermediate"
                        ? IntermediateImage
                        : AdvancedImage
                    }
                    // style={{
                    //   height: isMobile ? "50vh" : "20vh",
                    //   width: "5vh",
                    // }}
                    style={{
                      width: isMobile ? "250px" : "350px",
                      height: isMobile ? "200px" : "300px",
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      color: "white",
                      top: "40%",
                      // left: "30%",
                      left: isMobile ? "20%" : isLarge ? "20%" : "25%",
                      // maxWidth: "50%",
                      // transform: isMobile
                      //   ? "translateX(-50%)"
                      //   : "translateX(-95%)",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: isMobile ? "100%" : "120%",
                        // fontSize: isTablet ? (isMobile ? "3vh" : "8vh") : "7vh",
                        color: "white",
                        // fontWeight: "bold",
                        // borderBottom: "2px solid red",
                      }}
                    >
                      <span
                        style={{
                          fontWeight: "900",
                        }}
                      >
                        {module.name}
                      </span>
                      <br />
                      <span
                        style={{
                          fontWeight: "500",
                        }}
                      >
                        Module {module.examinationId}
                      </span>
                      <br />
                      <span
                        style={{
                          fontWeight: "300",
                        }}
                      >
                        No. of levels - 3
                      </span>
                    </Typography>
                  </div>
                </div>
              </Card>
            </Grid>
          ))}
      </Grid>
    </div>
  );
};
export default Modules;
